import { TypeGroupIds } from './../../modules/shared/constants/category-groupid.constants';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AccountUserService } from '../../service/account.service';
import { BehaviorSubject, lastValueFrom, map, Observable } from 'rxjs';
import { AppMainComponent } from 'src/app/app.main.component';
import { IVendorRma } from '../sales-order/models/customer-return.model';
import { IVendorCredit, IVendorCreditListRequestParams } from './vendor-credit/model/vendor-credit.model';

@Injectable({
  providedIn: 'root'
})
export class PurchasesService {

  //Behavior Subject for Vendor
  private vendor = new BehaviorSubject('');

  getVendorList(): Observable<any> {
    return this.vendor.asObservable();
  }

  setVendorList(list) {
    this.vendor.next(list);
  }

  //Behavior Subject for Bill
  private bill = new BehaviorSubject('');

  getBillStatus(): Observable<any> {
    return this.bill.asObservable();
  }

  setBillStatus(status) {
    this.bill.next(status);
  }

  appUrl = "";
  localAppUrl = "";
  coreUrl = "";
  user: any;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  constructor(private http: HttpClient, private accountUserService: AccountUserService) {
    this.appUrl = environment.apiUrl + "Cases/";
    this.coreUrl = environment.coreUrl;
    this.localAppUrl = environment.localApiUrl;
    this.getCurrentToken();
  }

  getLoggedUser(userId) {
    return this.http.get<any>(this.localAppUrl + 'users/' + userId)
      .toPromise()
      .then(res => res);
  }
  getCurrentToken() {
    this.accountUserService.user.subscribe(x => this.user = x);
  }

  getAllPurchaseChannels() {
    return this.http.get<any>(this.localAppUrl + 'allPurchaseStages')
      .toPromise()
      .then(res => res);
  }

  getPOConfigurations(name): Observable<any> {
    return this.http.get<any>(`${environment.configUrl}Configuration/ConfigurationsByModuleName?name=${name}`);
  }

  getAllOrders(pageNo, pageSize, searchValue, searchColumn, sortBy, isAscending, filters, isActive) {
    let params = new HttpParams();
    params = (!pageNo ? params : params.append('PageNumber', pageNo))
    params = (!pageSize ? params : params.append('PageSize', pageSize))
    params = params.append('isActive', isActive)
    params = (!isAscending ? params : params.append('IsAscending', isAscending))
    params = (!sortBy ? params : params.append('SortBy', sortBy))
    params = (!searchColumn ? params : params.append('SearchColumns', searchColumn))
    params = (!searchValue ? params : params.append('SearchValue', searchValue))
    params = (!filters ? params : params.append('filter', filters))
    return this.http.get<any>(`${environment.purchaseURl}Purchase`, { observe: 'response', params })
      .toPromise()
      .then(res => ({
        orders: res.body,
        headers: JSON.parse(res.headers.get('x-pagination')) //{TotalCount: 91, PageSize: 10, CurrentPage: 1, TotalPages: 10, HasNext: true, HasPrevious: false});
      }))
  }

  loadAllUOMCategory(): Observable<any> {
    return this.http.get<any>(`${environment.inventoryURl}Category/GetAllCategoryByGroupName?groupName=UnitOfMeasure`);
  }

  getAllLocations(): Observable<any> {
    let params = new HttpParams();
    params = params.append('PageNumber', '0')
    params = params.append('PageSize', '0')
    params = params.append('SearchValue', '')
    return this.http.get<any>(`${environment.inventoryURl}WareHouse/AllWarehouseDetails`, { params });
  }

  getAllVendors(pageNo, pageSize, searchValue, searchColumn, sortBy, isAscending, filters, isActive) {
    let params = new HttpParams();
    params = (!pageNo ? params : params.append('PageNumber', pageNo))
    params = (!pageSize ? params : params.append('PageSize', pageSize))
    params = params.append('isActive', isActive)
    params = (!isAscending ? params : params.append('IsAscending', isAscending))
    params = (!sortBy ? params : params.append('SortBy', sortBy))
    params = (!searchColumn ? params : params.append('SearchColumns', searchColumn))
    params = (!searchValue ? params : params.append('SearchValue', searchValue))
    params = (!filters ? params : params.append('filter', filters))
    return this.http.get<any>(`${environment.inventoryURl}Vendor`, { observe: 'response', params })
      .toPromise()
      .then(res => ({
        vendors: res.body,
        headers: JSON.parse(res.headers.get('x-pagination')) //{TotalCount: 91, PageSize: 10, CurrentPage: 1, TotalPages: 10, HasNext: true, HasPrevious: false});
      }))
  }

  getAllVendorTransactions(pageNo, pageSize, vendorId, transType) {
    let params = new HttpParams();
    params = params.append('pagenumber', pageNo)
    params = params.append('pageSize', pageSize)
    params = params.append('vendorId', vendorId)
    params = params.append('type', transType)
    return this.http.get<any>(`${environment.purchaseURl}Purchase/VendorTransactionsByType`, { observe: 'response', params })
      .toPromise()
      .then(res => ({
        transactions: res.body,
        headers: JSON.parse(res.headers.get('x-pagination')) //{TotalCount: 91, PageSize: 10, CurrentPage: 1, TotalPages: 10, HasNext: true, HasPrevious: false});
      }))
  }

  getAllVendorReturns(pageNo, pageSize, searchValue, searchColumn, sortBy, isAscending, filters,isGlobalSearch) {
      let params = new HttpParams();
      params = (!isGlobalSearch ? params : params.append('isGlobalSearch', isGlobalSearch))
      params = (!pageNo ? params : params.append('PageNumber', pageNo))
      params = (!pageSize ? params : params.append('PageSize', pageSize))
      // params = params.append('isActive', isActive)
      params = (!isAscending ? params : params.append('IsAscending', isAscending))
      params = (!sortBy ? params : params.append('SortBy', sortBy))
      params = (!searchColumn ? params : params.append('SearchColumns', searchColumn))
      params = (!searchValue ? params : params.append('SearchValue', searchValue))
      params = (!filters ? params : params.append('filter', filters))
      return this.http.get<any>(`${environment.purchaseURl}VendorRMA`, { observe: 'response', params })
        .toPromise()
        .then(res => ({
          vendors: res.body,
          headers: JSON.parse(res.headers.get('x-pagination'))
        }))
    }

  createVendorReturn(isBaseCurrency,customerReturn: IVendorRma) {

    const purchasesOrderUrl = `${environment.purchaseURl}VendorRMA?isBaseCurrency=${isBaseCurrency}`;

    return this.http
        .post<any>(purchasesOrderUrl, customerReturn)
        .toPromise()
        .then((res) => res);
}

checkSerialNoInVendorRMASystem(serialNo, warehouseId,productId,vendorRMAId? ): Observable<any> {
  let params = new HttpParams();
  params = vendorRMAId ? params.append('vendorRMAId', vendorRMAId): params;
  params = !vendorRMAId ? params.append('isVendorRMA', true): params;
  return this.http.get<any>(`${environment.inventorySalesUrl}Serial/CheckSerialAssociation?serial=${serialNo}&productIds=${productId}&warehouseId=${warehouseId}`, {params});
}

checkSerialNoInVendorReturnSystem(warehouseId,productId,billId,vendorRMAid?){
  let params = new HttpParams();
  params = params.append('isVendorRMA', 'true');
  return this.http.get<any>(`${environment.inventoryURl}Product/SerialListForOrders?productId=${productId}&warehouseId=${warehouseId}&billId=${billId}`, {params});
}

checkSystemTrackingDataForBill(pageNumber,pageSize,productId,warehouseId,billId,searchValue,isReturn){
  let params = new HttpParams();
  params =  params.append('pageNumber', pageNumber);
  params =  params.append('pageSize', pageSize);
  params =  params.append('isReturn', isReturn);
  params =  (!billId ? params : params.append('billId', billId))
  params =  params.append('productId', productId);
  params =  params.append('warehouseId', warehouseId);
  params = (!searchValue ? params : params.append('SearchValue', searchValue))
  return this.http.get<any>(`${environment.inventoryURl}Product/SerialListForOrdersView`,  { observe: 'response', params: params }).pipe(
    map((res: HttpResponse<any>) => {
      return {
        tracking: res.body,
        headers: JSON.parse(res.headers.get('x-pagination'))
      };
    })
  )
}

checkSystemTrackingData(productId,warehouseId,billId,refField,dataString,isVendorRMA){ 
  let params = new HttpParams();
  params =  params.append('productId', productId);
  params =  params.append('warehouseId', warehouseId);
  params =  (!billId ? params : params.append('billId', billId));
  params = (!refField ? params : params.append('referenceId', refField) )
  params = params.append('isVendorRMA', isVendorRMA)
  return this.http.post<any>(`${environment.inventoryURl}Product/CheckSerialForView`, dataString, {params});
}


getRmaStageChangeHistory(rmaId, objectId){
  const updateRmaStageUrl = `${environment.purchaseURl}VendorRMA/RmaStageHistory/${rmaId}?objectId=${objectId}`;
  return this.http.get<any>(updateRmaStageUrl);
}

updateRmaStage(rmaId, stageId,returnTypeId,reasonId, attachmentId, stageData): Promise<any>{
  const updateRmaStageUrl = `${environment.purchaseURl}VendorRMA/UpdateStage/${rmaId}?stageId=${stageId}&returnTypeId=${returnTypeId}&reasonId=${reasonId}&attachmentId=${attachmentId}`;
  return this.http.put<any>(updateRmaStageUrl, stageData)
      .toPromise()
      .then((res) => res);
}

getAllBillsByVendorId(vendorId: number, warehouseId: number){
  return this.http.get<any>(`${environment.purchaseURl}VendorRMA/BillListByVendor?vendorId=${vendorId}&warehouseId=${warehouseId}&isRMAList=false`);
}

getBillOrderItemsByBillId(vendorId: number, billId: number){
  const invoiceOrderItemsUrl = `${environment.purchaseURl}BillOrder/GetAllBillItemsByBillOrderId/${vendorId}/${billId}`;

  return this.http.get<any>(invoiceOrderItemsUrl);
}

getSerialNumbers(vendortId: number,warehouseId: number, serialNumber: String){
  const invoiceOrderItemsUrl = `${environment.purchaseURl}BillOrder/SerialNumberList?vendorId=${vendortId}&warehouseId=${warehouseId}&serialNumber=${serialNumber}`;

  return this.http.get<any>(invoiceOrderItemsUrl);
}

getBillOrderItemsBySerialNumber(vendortId: number,warehouseId: number, serialNumber: String){
  const invoiceOrderItemsUrl = `${environment.purchaseURl}BillOrder/GetAllBillItemsBySerialNumber?vendorId=${vendortId}&warehouseId=${warehouseId}&serialNumber=${serialNumber}`;

  return this.http.get<any>(invoiceOrderItemsUrl);
}


getItemNumbers(vendorId: any, warehouseId: any, itemNumber: any)
{
    const itemNumbersUrl = `${environment.purchaseURl}BillOrder/ItemNumberList?vendorId=${vendorId}&warehouseId=${warehouseId}&itemNumber=${itemNumber}`;

    return this.http.get<any>(itemNumbersUrl);
}

getBillOrderItemsByItemNumber(vendorId: any, warehouseId: any, itemNumber: any)
{
    const itemNumbersUrl = `${environment.purchaseURl}BillOrder/GetAllBillItemsByItemNumber?vendorId=${vendorId}&warehouseId=${warehouseId}&itemNumber=${itemNumber}`;

    return this.http.get<any>(itemNumbersUrl);
}

deleteVendorReturn(id,action) {
  let params = new HttpParams();
  params = action == 'delete' ? params : params.append("isVoid", true);
  let deleteVendorReturnUrl = `${environment.purchaseURl}VendorRma/${id}`;
  return this.http.delete<any>(deleteVendorReturnUrl, {params}).toPromise()
    .then(res => res);
}

getVendorReturnDetails(id){
  const vendorReturnDetailsUrl = `${environment.purchaseURl}VendorRma/${id}`;
  return this.http.get<any>(vendorReturnDetailsUrl);
}

updateVendorReturn(isBaseCurrency,vendorReturn: IVendorRma) {

  const purchasesOrderUrl = `${environment.purchaseURl}VendorRma?isBaseCurrency=${isBaseCurrency}`;

  return this.http
      .put<any>(purchasesOrderUrl, vendorReturn)
      .toPromise()
      .then((res) => res);
}

  getAllPayments(pageNo, pageSize, searchValue, searchColumn, sortBy, isAscending, filters) {
    let params = new HttpParams();
    params = (!pageNo ? params : params.append('PageNumber', pageNo))
    params = (!pageSize ? params : params.append('PageSize', pageSize))
    params = (!isAscending ? params : params.append('IsAscending', isAscending))
    params = (!sortBy ? params : params.append('SortBy', sortBy))
    params = (!searchColumn ? params : params.append('SearchColumns', searchColumn))
    params = (!searchValue ? params : params.append('SearchValue', searchValue))
    params = (!filters ? params : params.append('filters', filters))
    return this.http.get<any>(`${environment.purchaseURl}BillPayment`, { observe: 'response', params })
      .toPromise()
      .then(res => ({
        bills: res.body,
        headers: JSON.parse(res.headers.get('x-pagination')) //{TotalCount: 91, PageSize: 10, CurrentPage: 1, TotalPages: 10, HasNext: true, HasPrevious: false});
      }))
  }


  addBill(data) {
    return this.http.post<any>(`${environment.purchaseURl}BillPayment`, data)
      .toPromise()
      .then(res => res);
  }

  updateBill(data) {
    return this.http.put<any>(`${environment.purchaseURl}BillPayment`, data)
      .toPromise()
      .then(res => res);
  }

  getPaymentById(id) {
    return this.http.get<any>(`${environment.purchaseURl}BillPayment/${id}`);
  }

  getBillsByVendorId(vendorId) {
    return this.http.get<any>(`${environment.purchaseURl}BillPayment/RPOBillsByVendorId?vendorId=${vendorId}`);
  }

  getAllPOVendors() {
    return this.http.get<any>(`${environment.inventoryURl}Vendor/VendorNames?includeDeleted=true`);
  }

  getAllProductsBySearch(typeId, pageNo, pageSize, vendorId, searchValue) {
    let params = new HttpParams();
    params = !searchValue ? params : params.append("search", searchValue);
    params = !vendorId ? params : params.append("vendorId", vendorId);
    params = !pageNo ? params : params.append("PageNumber", pageNo);
    params = !pageSize ? params : params.append("PageSize", pageSize);
    return this.http
      .get<any>(
        `${environment.inventorySalesOrderUrl}Product/GetVendorProductsBySearch?typeId=${typeId}`,
        { observe: "response", params }
      )
      .toPromise()
      .then((res) => ({
        inventory: res.body,
        headers: JSON.parse(res.headers.get("x-pagination")),
      }));
  }

  getPaymentTermList() {
    return this.http.get<any>(`${environment.coreUrl}PaymentTerm`);
  }

  addAccountOpeningBalance(Obj,startingdate) {
    return this.http.post<any>(`${environment.inventoryURl}Vendor/AddOpeningBalance?vendorId=${Obj.accountId}&openingBalance=${Obj.openingBalance}&startingDate=${startingdate}`,Obj)
  }

  getPaymentMethodList() {
    return this.http.get<any>(`${environment.coreUrl}PaymentMethod`);
  }

  getShippingMethodList() {
    return this.http.get<any>(`${environment.coreUrl}ShippingMethod/ShippingMethodHierarchy`);
  }

  getShippingTermList() {
    return this.http.get<any>(`${environment.inventoryURl}ShippingTerm`);
  }

  getAllTax() {
    // return this.http.get<any>(`${environment.inventorySalesOrderUrl}Tax`);
    return this.http.get<any>(`${environment.inventoryURl}Tax/TaxConfiguration`);
  }

  getAllDiscount() {
    return this.http.get<any>(`${environment.inventoryURl}Discount/DiscountConfiguration`);
  }

  getAllGroups() {
    return this.http.get<any>(`${environment.inventorySalesUrl}Group`);
  }

  getAllInventoryGroups() {
    return this.http.get<any>(`${environment.inventoryURl}Group`);
  }

  getAllRPO(id) {
    return this.http.get<any>(`${environment.purchaseURl}ReceivePurchaseOrder/GetAllRPOByPurchaseOrderId?PurchaseOrderId=${id}`);
  }

  getVendorTypeList(groupId) {
    return this.http.get<any>(
      `${environment.inventoryURl}Type?groupId=${groupId}`
    );
  }

  getRPOById(id,includeSerial?) {
    let params = new HttpParams();
    params = !includeSerial ? params : params.append("includeSerial", includeSerial);
    return this.http.get<any>(`${environment.purchaseURl}ReceivePurchaseOrder/${id}`, {params});
  }

  getRPOListByVendor(vendorId,warehouseId){
    return this.http.get<any>(`${environment.purchaseURl}ReceivePurchaseOrder/ItemReceiptsByVendorId?vendorId=${vendorId}&locationId=${warehouseId}`);
  }

  mergeBill(data) {
    return this.http.post<any>(`${environment.purchaseURl}BillOrder/MergeItemReceiptToBill`, data)
      .toPromise()
      .then(res => res);
  }

  getGroupById(groupId) {
    return this.http.get<any>(
      `${environment.inventoryURl}Type?groupId=${groupId}`
    );
  }

  addPurchaseOrder(data,isBaseCurrency) {
    return this.http.post<any>(`${environment.purchaseURl}Purchase?isBaseCurrency=${isBaseCurrency}`, data)
      .toPromise()
      .then(res => res);
  }

  updatePurchaseOrder(data,isBaseCurrency) {
    return this.http.put<any>(`${environment.purchaseURl}Purchase?isBaseCurrency=${isBaseCurrency}`, data)
      .toPromise()
      .then(res => res);
  }

  addReceivePurchaseOrder(data,isBaseCurrency) {
    return this.http.post<any>(`${environment.purchaseURl}ReceivePurchaseOrder?isBaseCurrency=${isBaseCurrency}`, data)
      .toPromise()
      .then(res => res);
  }

  updateReceivePurchaseOrder(data,isBaseCurrency) {
    return this.http.put<any>(`${environment.purchaseURl}ReceivePurchaseOrder?isBaseCurrency=${isBaseCurrency}`, data)
      .toPromise()
      .then(res => res);
  }

  addItemTrackingForRPO(data) {
    return this.http.post<any>(`${environment.purchaseURl}ReceivePurchaseOrder/AddSerialDetail`, data)
      .toPromise()
      .then(res => res);
  }

  getPOById(id,showSerial?) {
    let params = new HttpParams();
    params = !showSerial ? params : params.append("showSerial", true);
    return this.http.get<any>(
      `${environment.purchaseURl}Purchase/${id}`, {params}
    );
  }

  getVendorById(id) {
    let params = new HttpParams();
    params = params.append("includeDeleted", true);
    return this.http.get<any>(`${environment.inventoryURl}Vendor/${id}`, {params});
  }

  addVendor(data) {
    return this.http.post<any>(`${environment.inventoryURl}Vendor`, data)
      .toPromise()
      .then(res => res);
  }


  updateVendor(data) {
    return this.http.put<any>(`${environment.inventoryURl}Vendor`, data)
      .toPromise()
      .then(res => res);
  }

  addVendorContact(data) {
    return this.http.post<any>(`${environment.inventoryURl}Vendor/Contact`, data)
      .toPromise()
      .then(res => res);
  }

  updateVendorContact(data) {
    return this.http.put<any>(`${environment.inventoryURl}Vendor/Contact`, data)
      .toPromise()
      .then(res => res);
  }

  deleteVendorContact(id) {
    return this.http.delete<any>(`${environment.inventoryURl}Vendor/Contact/${id}`)
      .toPromise()
      .then(res => res);
  }

  deletePO(id) {
    return this.http.delete<any>(
      `${environment.purchaseURl}Purchase/${id}`
    ).toPromise()
      .then(res => res);
  }

  voidPO(id) {
    return this.http.delete<any>(
      `${environment.purchaseURl}Purchase/Void?purchaseId=${id}`
    ).toPromise()
      .then(res => res);
  }

  deleteBill(id: number, isVoid :boolean): Promise<any> {
    const params = !isVoid ? new HttpParams() : new HttpParams().set("isVoided", "true");
    const billPaymentUrl = `${environment.purchaseURl}BillPayment/${id}`;
    return this.http.delete<any>(billPaymentUrl, { params }).toPromise();
  }

  deleteVendor(id) {
    return this.http.delete<any>(
      `${environment.inventoryURl}Vendor/${id}`
    ).toPromise()
      .then(res => res);
  }

  voidRPO(id,isVoid) {
    return this.http.delete<any>(
      `${environment.purchaseURl}ReceivePurchaseOrder/${id}?isVoid=${isVoid}`
    ).toPromise()
      .then(res => res);
  }

  getAllTimezone() {
    return this.http.get<any>(
      `${environment.coreUrl}TimeZone`
    );
  }

  getAnnualRevenue() {
    return this.http.get<any>(
      `${environment.coreUrl}AnnualRevenue`
    );
  }

  getOwnerShips() {
    return this.http.get<any>(
      `${environment.coreUrl}OwnerShip`
    );
  }

  getIndustry() {
    return this.http.get<any>(
      `${environment.coreUrl}Industry`
    );
  }

  getEmployeesCount() {
    return this.http.get<any>(
      `${environment.configUrl}EmployeeCount`
    );
  }

  getCurrency() {
    return this.http.get<any>(
      `${environment.coreUrl}CurrencyUnit`
    );
  }

  getCountry() {
    return this.http.get<any>(`${environment.coreUrl}Country`);
  }

  getAllStates(countryId: number) {
    return this.http.get<any>(`${environment.coreUrl}State`, {
      params: new HttpParams().append("countryId", countryId.toString())
    })
      .toPromise()
      .then(res => res);
  }

  getAllCities(stateId) {
    return this.http.get<any>(`${environment.coreUrl}City`, {
      params: new HttpParams().append("stateId", stateId.toString())
    })
      .toPromise()
      .then(res => res);
  }

  getAddressTypes() {
    return this.http.get<any>(`${environment.coreUrl}Address/AddressType`);
  }

  getContactAssociationTypes() {
    return this.http.get<any>(`${environment.contactURL}ContactAssociationType`);
  }

  getContactEmailTypes() {
    return this.http.get<any>(`${environment.contactURL}Email/EmailType`);
  }

  getContactPhoneTypes() {
    return this.http.get<any>(`${environment.contactURL}Phone/PhoneType`);
  }

  getSocialProfileTypes() {
    return this.http.get<any>(`${environment.contactURL}SocialProfile/SocialProfileType`);
  }

  addVendorAddressType(data) {
    return this.http.post<any>(`${environment.coreUrl}Type`, data);
  }

  getGender() {
    return this.http.get<any>(`${environment.coreUrl}Gender`);
  }

  getLanguage() {
    return this.http.get<any>(`${environment.coreUrl}Language`);
  }


  getSalutations() {
    return this.http.get<any>(`${environment.contactURL}Salutation`);
  }

  getContactRoles() {
    return this.http.get<any>(`${environment.contactURL}Type?groupId=${TypeGroupIds.JobFuctionsContactAPI}`);
  }

  getAllAssistant(companyId) {
    return this.http.get<any>(`${environment.contactAPI}/LionO360/2.0/API/Contact?organizationId=${companyId}`);
  }

  // getAllFinancialAccounts() {
  //   return this.http.get<any>(`${environment.financeURl}FinancialAccount/GetFinancialAccounts`);
  // }

  getAllFinancialAccounts() {
    return this.http.get<any>(`${environment.financeURl}FinancialAccount?accountType=0&showBalance=false`);
  }

  getAllBankFinancialAccounts() {
    return this.http.get<any>(`${environment.financeURl}FinancialAccount/BillFinancialAccount`);
  }

  getAllCustomRules() {
    return this.http.get<any>(`${environment.inventoryURl}CustomRules`);
  }

  addState(data: object) {
    return this.http.post<any>(`${environment.coreUrl}State`, data)
      .toPromise()
      .then(res => res);
  }

  addCity(data: object) {
    return this.http.post<any>(`${environment.coreUrl}City`, data)
      .toPromise()
      .then(res => res);
  }

  getFOBList() {
    return this.http.get<any>(`${environment.inventoryURl}FOBPoint`);
  }

  getAllRPOs(pageNo,pageSize,isActive,isAscending,searchColumn,searchValue,filters) {
    let params = new HttpParams();
    params = !pageNo ? params : params.append("PageNumber", pageNo);
    params = !pageSize ? params : params.append("PageSize", pageSize);
    params = params.append('isActive', isActive)
    params = (!isAscending ? params : params.append('IsAscending', isAscending))
    // params = (!sortBy ? params : params.append('SortBy', sortBy))
    params = (!searchColumn ? params : params.append('SearchColumns', searchColumn))
    params = (!searchValue ? params : params.append('SearchValue', searchValue))
    params = (!filters ? params : params.append('filter', filters))
    return this.http
      .get<any>(
        `${environment.purchaseURl}ReceivePurchaseOrder`,
        { observe: "response", params }
      )
      .toPromise()
      .then((res) => ({
        rpos: res.body,
        headers: JSON.parse(res.headers.get("x-pagination")),
      }));
  }

  getVendorListByPO(isBillMerge) {
    return this.http.get<any>(`${environment.inventoryURl}Vendor/PurchaseOrderVendorNames?includeDeleted=false&isBillMerge=${isBillMerge}`);
  }

  getVendorListByBills() {
    return this.http.get<any>(`${environment.inventoryURl}Vendor/BillVendorNames?includeDeleted=true`);
  }

  getPOListByVendor(pageNo,pageSize,vendorId,search,rpoId?) {
    let params = new HttpParams();
    params = params.append("PageNumber", pageNo);
    params = params.append("PageSize", pageSize);
    params = params.append("SearchValue", search);
    params = rpoId ? params.append("rpoId", rpoId) : params;
    return this.http.get<any>(`${environment.purchaseURl}Purchase/PurchaseOrderVendor?vendorId=${vendorId}`, {params});
  }

  //Bills
  createBill(data,isBaseCurrency){
      return this.http.post<any>(`${environment.purchaseURl}BillOrder?isBaseCurrency=${isBaseCurrency}`, data)
        .toPromise()
        .then(res => res);
  }

  updateNewBill(data,isBaseCurrency){
    return this.http.put<any>(`${environment.purchaseURl}BillOrder?isBaseCurrency=${isBaseCurrency}`, data)
      .toPromise()
      .then(res => res);
}

  getAllNewBills(pageNo,pageSize,isActive,isAscending,searchColumn,searchValue,filters,fromDate,toDate) {
    let params = new HttpParams();
    params = !pageNo ? params : params.append("PageNumber", pageNo);
    params = !pageSize ? params : params.append("PageSize", pageSize);
    params = params.append('fromDate', fromDate)
    params = params.append('toDate', toDate)
    //params = params.append('isActive', isActive)
    params = (!isAscending ? params : params.append('IsAscending', false))
    // params = (!sortBy ? params : params.append('SortBy', sortBy))
    params = (!searchColumn ? params : params.append('SearchColumns', searchColumn))
    params = (!searchValue ? params : params.append('SearchValue', searchValue))
    params = (!filters ? params : params.append('filter', filters))
    return this.http
      .get<any>(
        `${environment.purchaseURl}BillOrder`,
        { observe: "response", params }
      )
      .toPromise()
      .then((res) => ({
        bills: res.body,
        headers: JSON.parse(res.headers.get("x-pagination")),
      }));
  }

  getBillById(billId){
    return this.http.get<any>(`${environment.purchaseURl}BillOrder/${billId}`);
}

voidBill(id,isVoid) {
  return this.http.delete<any>(
    `${environment.purchaseURl}BillOrder/${id}?isVoid=${isVoid}`
  ).toPromise()
    .then(res => res);
}

getWarehouseWiseProductBarcode(data) {
  let params = new HttpParams();
  params = !data.locationId ? params : params.append("warehouseId", data.locationId);
  params = !data.vendorId ? params : params.append("vendorId", data.vendorId);
  params = !data.pageNumber ? params : params.append("PageNumber", data.pageNumber);
  params = !data.pageSize ? params : params.append("PageSize", data.pageSize);
  params = !data.searchValue ? params : params.append("SearchValue", data.searchValue);
  return this.http
      .get<any>(
          `${environment.inventoryURl}Product/VendorProductsByBarcode`,
          { observe: "response", params }
      )
      .toPromise()
      .then((res) => ({
          inventory: res.body,
          headers: JSON.parse(res.headers.get("x-pagination")),
      }));
}

bulkImportSerials(rpoId,billOrderId,warehouseId,data){
  return this.http.post<any>(`${environment.purchaseURl}ReceivePurchaseOrder/bulkImportSerial?receivedPurchaseOrderId=${rpoId}&purchaseOrderId=0&billOrderid=${billOrderId}&warehouseId=${warehouseId}`, data);
}

checkSerialNoInSystem(warehouseId,productId,isPO?,rpoId?,billOrderId?){
  let params = new HttpParams();
  params = !billOrderId ? params : params.append("billId", billOrderId);
  params = !rpoId ? params : params.append("rpoId", rpoId);
  params = !isPO ? params : params.append("isPO", isPO);
  return this.http.get<any>(`${environment.inventoryURl}Product/SerialListForOrders?productId=${productId}&warehouseId=${warehouseId}`, {params});
}

getPOProductSerialDetails(purchaseId,productId,subProductId){
  return this.http.get<any>(`${environment.purchaseURl}Purchase/SerialDetailByPurchaseId?purchaseId=${purchaseId}&productId=${productId}&subProductId=${subProductId}`);
}

getItemReceiptProductSerialDetails(rpoId,productId,subProductId){
  return this.http.get<any>(`${environment.purchaseURl}ReceivePurchaseOrder/SerialDetailByRPOId?rpoId=${rpoId}&productId=${productId}&subProductId=${subProductId}`);
}

  getBillProductSerialDetails(billOrderId,productId,subProductId){
    return this.http.get<any>(`${environment.purchaseURl}BillOrder/SerialDetailByBillId?billOrderId=${billOrderId}&productId=${productId}&subProductId=${subProductId}`);
  }

  checkSerialNoInAllSystem(serialNo, warehouseId, productId): Observable<any> {
    return this.http.get<any>(`${environment.inventorySalesUrl}Serial/CheckSerialAssociation?serial=${serialNo}&productIds=${productId}&warehouseId=${warehouseId}&IsPurchaseOrder=true`);
  }

  loadTrackingOptions(): Observable<any>{
    return this.http.get<any>(`${environment.inventoryURl}TrackingSetting`);
  }

  getAllCustomFields(id) {
    return this.http.get<any>(`${environment.configUrl}Configuration/CustomAttributes?objectId=${id}`)
        .toPromise()
        .then(res => res);
  }

  getTransaction(vendorId: number, acctranstypeid: number) {
    return this.http.get<any>(`${environment.financeURl + "FinancialReport/GetVendorFinanceTransaction"}?vendorID=${vendorId}&acctranstypeid=${acctranstypeid}`);
  }

  getPurchaseHistory(vendorId,pageNo,pageSize,searchValue){
    let params = new HttpParams();
    params =  params.append('PageNumber', pageNo)
    params =  params.append('PageSize', pageSize)
    params = params.append('searchValue', searchValue)
    return this.http.get<any>(`${environment.financeURl}FinancialReport/GetVendorPurchaseHistory?vendorId=${vendorId}`, {observe: 'response', params})
        .toPromise()
        .then(res =>  ({
        data: res.body,
        headers: JSON.parse(res.headers.get('x-pagination'))
    }));
  }

  /** Vendor Credit */
  getAllVendorCredits(vendorCreditListRequestParams: IVendorCreditListRequestParams) {
    let params = new HttpParams();
    params = (!vendorCreditListRequestParams?.pageNumber ? params : params.append('PageNumber', vendorCreditListRequestParams.pageNumber));
    params = (!vendorCreditListRequestParams?.pageSize ? params : params.append('PageSize', vendorCreditListRequestParams.pageSize));
    params = (!vendorCreditListRequestParams?.searchColumns ? params : params.append('SearchColumns', vendorCreditListRequestParams.searchColumns));
    params = (!vendorCreditListRequestParams?.searchValue ? params : params.append('SearchValue', vendorCreditListRequestParams.searchValue));
    params = (!vendorCreditListRequestParams?.filter ? params : params.append('filter', vendorCreditListRequestParams.filter));
    params = params.append('isActive', vendorCreditListRequestParams.isActive);
    params = params.append('IsAscending', vendorCreditListRequestParams.isAscending);
    
    // params = (!vendorCreditListRequestParams?.sortBy ? params : params.append('SortBy', sortBy));
    // params = (!vendorCreditListRequestParams?.filters ? params : params.append('filter', filters));
    
    return this.http.get<any>(`${environment.inventoryURl}VendorCredit/PageList`, { observe: 'response', params })
      .toPromise()
      .then(res => ({
        vendorCredits: res.body,
        headers: JSON.parse(res.headers.get('x-pagination'))
      }))
  }


  saveVendorCredit(isBaseCurrency: boolean, vendorCredit: IVendorCredit) {
    const url = `${environment.inventoryURl}VendorCredit?isBaseCurrency=${isBaseCurrency}`;
    return this.http.post<any>(url, vendorCredit);
}
  updateVendorCredit(isBaseCurrency,vendorCredit: IVendorCredit) {
    const url = `${environment.inventoryURl}VendorCredit?isBaseCurrency=${isBaseCurrency}`;
    return this.http.put<any>(url, vendorCredit);
  }

  getVendorCreditById(vendorCreditId: number) {
    return this.http.get<any>(`${environment.inventoryURl}VendorCredit/${vendorCreditId}`);
  }

  deleteVendorCredit(vendorCreditId: number) {
    return this.http.delete<any>(`${environment.inventoryURl}VendorCredit/${vendorCreditId}`);
  }

  getTransactionsByVendorCreditId(vendorCreditId: number) {
    return this.http.get<any>(`${environment.purchaseURl}BillPayment/PaymentByCredit?vendorCreditId=${vendorCreditId}`);
  }
  deleteVendorCreditEntry(vendorCreditId: number): Promise<any> {
    return lastValueFrom(
      this.http.delete<any>(`${environment.inventoryURl}VendorCredit/${vendorCreditId}`)
    );
  }
  getVendorCreditByVendor(vendorId: number, vendorCreditId: number, billOrderId: number, isPayment: boolean, checkId: number) {
    return this.http.get<any>(`${environment.purchaseURl}BillPayment/VendorCreditByVendor?vendorId=${vendorId}&vendorCreditId=${vendorCreditId}&billOrderId=${billOrderId}&isPayment=${isPayment}&checkId=${checkId}`);
  }

  getVendorCreditProductSerialDetails(vendorCreditId, productId){
    return this.http.get<any>(`${environment.inventoryURl}VendorCredit/SerialDetailByVendorCreditId?vendorCreditId=${vendorCreditId}&vendorCreditProductId=${productId}`);
  }

  //apply credit
  getCreditByVendorId(vendorId: number,billPaymentId: number) {
    let params = new HttpParams();
    params = (!billPaymentId ? params : params.append('billPaymentId',billPaymentId));
    return this.http.get<any>(`${environment.purchaseURl}BillPayment/VendorCreditByVendor?vendorId=${vendorId}&vendorCreditId=null&billOrderId=0&isPayment=true`, {params});
  }

  checkSerialNoInAllSystemForVendorCredit(serialNo, warehouseId, productId): Observable<any> {
    return this.http.get<any>(`${environment.inventorySalesUrl}Serial/CheckSerialAssociation?serial=${serialNo}&productIds=${productId}&warehouseId=${warehouseId}&IsVendorCredit=true`);
  }
  checkSerialNoInAllSystemByVendorCreditId(serialNo, warehouseId, productId, VendorCreditId): Observable<any> {
    return this.http.get<any>(`${environment.inventorySalesUrl}Serial/CheckSerialAssociation?serial=${serialNo}&productIds=${productId}&warehouseId=${warehouseId}&vendorCreditId=${VendorCreditId}`);
  }
  checkSerialNoInSystemForVendorCredit(warehouseId,productId){
    return this.http.get<any>(`${environment.inventoryURl}Product/SerialListForOrders?productId=${productId}&warehouseId=${warehouseId}&isVendorCredit=true`);
  }
  checkSerialNoInSystemByVendorCreditId(warehouseId,productId, vendorCreditId){
    return this.http.get<any>(`${environment.inventoryURl}Product/SerialListForOrders?productId=${productId}&warehouseId=${warehouseId}&vendorCreditId=${vendorCreditId}`);
  }
}
